<template>

  <div class="group" :ref="refs[builder.doorProfile.fieldName + 'Group']">

    <div class="group-header l_no-footspace" :id="`${builder.doorProfile.fieldName}Title`">
      <div class="group-title">Choose your door profile:</div>
    </div>

    <Selector
      :key=builder.doorProfile.fieldName
      :field-name=builder.doorProfile.fieldName
      :display-type=builder.doorProfile.displayType
      :options=builder.doorProfile.options
      :selected=builder.currentItem.specs[builder.doorProfile.fieldName]
      options-source="doorProfileOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.panelFinish.fieldName + 'Group']">

    <div class="group-header l_no-footspace" :id="`${builder.panelFinish.fieldName}Title`">
      <div class="group-title">Choose your door and panel finishes:</div>
    </div>

    <div style="margin-top: 20px;" v-if="!builder.currentItem.specs.doorProfileId">
      <p>Please select a door profile to view the finish options.</p>
    </div>

    <Selector
      :key=builder.panelFinish.fieldName
      :field-name=builder.panelFinish.fieldName
      :display-type=builder.panelFinish.displayType
      :options=builder.panelFinish.options
      :selected=builder.currentItem.specs[builder.panelFinish.fieldName]
      options-source="panelFinishOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.handles.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.handles.fieldName}Title`">
      <div class="group-title">Choose your door handles</div>
    </div>

    <Selector
      :key=builder.handles.fieldName
      :field-name=builder.handles.fieldName
      :display-type=builder.handles.displayType
      :options=builder.handles.options
      :selected=builder.currentItem.specs[builder.handles.fieldName]
      options-source="handlesOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.hardware.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.hardware.fieldName}Title`">
      <div class="group-title">Choose your internal hardware options</div>
    </div>

    <Selector
      :key=builder.hardware.fieldName
      :field-name=builder.hardware.fieldName
      :display-type=builder.hardware.displayType
      :options=builder.hardware.options
      :selected=builder.currentItem.specs[builder.hardware.fieldName]
      options-source="hardwareOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.addRails.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.addRails.fieldName}Title`">
      <div class="group-title">Would you like any additional hanging rails?</div>
      <div class="group-help">Supplied at 1200mm to be cut to size</div>
    </div>

    <Selector
      :key=builder.addRails.fieldName
      :field-name=builder.addRails.fieldName
      :display-type=builder.addRails.displayType
      :options=builder.addRails.options
      :selected=builder.currentItem.specs[builder.addRails.fieldName]
      options-source="addRailsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.addShelves.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.addShelves.fieldName}Title`">
      <div class="group-title">Would you like any additional shelves?</div>
      <div class="group-help">Supplied at 1200mm to be cut to size</div>
    </div>

    <Selector
      :key=builder.addShelves.fieldName
      :field-name=builder.addShelves.fieldName
      :display-type=builder.addShelves.displayType
      :options=builder.addShelves.options
      :selected=builder.currentItem.specs[builder.addShelves.fieldName]
      options-source="addShelvesOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs['LabelGroup']">

    <div class="group-header" :id="`LabelTitle`">
      <div class="group-title">Label your wardrobe</div>
      <div class="group-help">Maximum 30 characters</div>
    </div>

    <Text-Input
    key="label"
    field-label="label"
    field-name="label"
    :init-value=builder.currentItem.label
    :init-touched="false"
    :placeholder="`Wardrobe ${builder.currentItem.ref}`"
    :maxlength="30"
    @update-value="updateProp"
    ></Text-Input>

  </div>

</template>

<script setup>

import { computed, ref, onMounted } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

function select(prop, opt) {
  builder.setCurrentItemSpec(prop, opt['id']);
}

function updateProp(prop, val) {
  builder.setCurrentItemProp(prop, val);
}

// init refs
let refHandles = [
  'LabelGroup',
  builder.config.fieldName + 'Group',
  builder.hardware.fieldName + 'Group',
  builder.panelFinish.fieldName + 'Group',,
  builder.requireHandles.fieldName + 'Group',
  builder.handles.fieldName + 'Group',
  builder.addRails.fieldName + 'Group',
  builder.addShelves.fieldName + 'Group',
];
if (builder.currentItem.data.doorsVal >= 1) refHandles.push(builder.panel1.fieldName + 'Group');
if (builder.currentItem.data.doorsVal >= 2) refHandles.push(builder.panel2.fieldName + 'Group');
if (builder.currentItem.data.doorsVal >= 3) refHandles.push(builder.panel3.fieldName + 'Group');
if (builder.currentItem.data.doorsVal >= 4) refHandles.push(builder.panel4.fieldName + 'Group');
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>
